var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { transformConfig } from 'mobx-little-router';
import { when } from 'mobx';

var handleAnimatedTransition = function handleAnimatedTransition(_ref) {
  var type = _ref.type,
      target = _ref.target;
  return new Promise(function (resolve, reject) {
    when(function () {
      return target.data.transitionState === (type === 'entering' ? 'entered' : 'exited');
    }, function () {
      resolve();
    });
  });
}; // Allow component and outlet to be specified within the config and automatically gets added to getData
// for a cleaner look and feel


export default transformConfig(function (config) {
  var component = config.component,
      outlet = config.outlet,
      animate = config.animate;
  var getData = component || outlet ? function (route) {
    return _extends({
      component: component,
      outlet: outlet,
      transitionState: null
    }, typeof config.getData === 'function' ? config.getData(route) : {});
  } : config.getData;
  var onTransition = animate ? handleAnimatedTransition : config.onTransition;
  return _extends({}, config, {
    getData: getData,
    onTransition: onTransition
  });
});